import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={19}
        height={19}
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.9144 3.57C14.2719 1.95 12.0219 0.9375 9.54688 0.9375C7.07183 0.9375 4.82188 1.94996 3.17938 3.57C1.55938 5.21246 0.546875 7.46246 0.546875 9.9375C0.546875 14.91 4.57437 18.9375 9.54688 18.9375C12.022 18.9375 14.2719 17.925 15.9144 16.305C17.5344 14.6625 18.5469 12.4125 18.5469 9.9375C18.5469 7.46246 17.5344 5.2125 15.9144 3.57ZM10.4469 14.5275C10.4469 15.0225 10.042 15.4274 9.54696 15.4274C9.05196 15.4274 8.64704 15.0225 8.64704 14.5275V8.4075C8.64704 7.9125 9.05196 7.50758 9.54696 7.50758C10.042 7.50758 10.4469 7.9125 10.4469 8.4075V14.5275ZM10.4469 5.5275C10.4469 6.0225 10.042 6.42742 9.54696 6.42742C9.05196 6.42742 8.64704 6.0225 8.64704 5.5275V5.34748C8.64704 4.85248 9.05196 4.44756 9.54696 4.44756C10.042 4.44756 10.4469 4.85248 10.4469 5.34748V5.5275Z"
            fill="#0A5587"
        />
    </svg>
);
export default SVGComponent;
